/**
 * Route for `volume-based-pricing-per-click-per-conversion`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { VolumeBasedPricingPerClickPerConversionPage } from "../features/volume-based-pricing-per-click-per-conversion/VolumeBasedPricingPerClickPerConversionPage";

export const volumeBasedPricingPerClickPerConversionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/volume-based-pricing-per-click-per-conversion",
	component: VolumeBasedPricingPerClickPerConversionPage,
});

export default volumeBasedPricingPerClickPerConversionRoute;
